import React, { Component } from 'react'
import './PrivacyPolicy.css';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class PrivacyPolicy extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />

                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="elementor-widget-container ctnr">
                        <h2 className="elementor-heading-title elementor-size-default">Privacy Policy</h2>
                    </div>
                    <div className="elementor-text-editor elementor-clearfix bdr fnt">
                        <p className="pg">
                            <span style={{"fontWeight": "400"}}>
                            We value the trust you place in us. That’s why we insist upon the highest standards for secure transactions and customer information privacy. Please read the following statement to learn about our information gathering and dissemination practices. Our privacy policy is subject to change at any time without notice. To make sure you are aware of any changes, please review this policy periodically. By visiting http://staging.stylecabbie.com (“Website”) you agree to be bound by the terms and conditions of this Privacy Policy. If you do not agree please do not use or access our Website. By mere use of the Website, you expressly consent to our use and disclosure of your personal information in accordance with this Privacy Policy. This Privacy Policy is incorporated into and subject to the Terms of Use
                            </span>
                        </p>
                        
                        <h3 className="pg ftr">
                            1. COLLECTION OF PERSONALLY IDENTIFIABLE INFORMATION AND OTHER INFORMATION
                        </h3>
                            <p className="pg">
                                <span style={{"fontWeight": "400"}}>
                                When you use our Website, we collect and store your personal information which is provided by you from time to time. Our primary goal in doing so is to provide you a safe, efficient, smooth and customized experience. This allows us to provide services and features that most likely meet your needs, and to customize our Website to make your experience safer and easier. More importantly, while doing so we collect personal information from you that we consider necessary for achieving this purpose.
                                </span>
                            </p>
                        
                        <h3 className="pg ftr">
                            2. USE OF DEMOGRAPHIC / PROFILE DATA / YOUR INFORMATION
                        </h3>
                            <p className="pg"><span style={{"fontWeight": "300"}}>
                            We use personal information to provide the services you request. To the extent we use your personal information to market to you, we will provide you the ability to opt-out of such uses. We use your personal information to resolve disputes; troubleshoot problems; help promote a safe service; collect money; measure consumer interest in our products and services, inform you about online and offline offers, products, services, and updates; customize your experience; detect and protect us against error, fraud and other criminal activity; enforce our terms and conditions; and as otherwise described to you at the time of collection.
                                </span>
                            </p>
                        
                        <h3 className="pg ftr">
                            3. SHARING OF PERSONAL INFORMATION
                        </h3>    
                            <p className="pg"><span style={{"fontWeight": "300"}}>
                            We may share personal information with our other corporate entities and affiliates. These entities and affiliates may market to you as a result of such sharing unless you explicitly opt-out. We may disclose personal information to third parties. This disclosure may be required for us to provide you access to our Services, to comply with our legal obligations, to enforce our User Agreement, to facilitate our marketing and advertising activities, or to prevent, detect, mitigate, and investigate fraudulent or illegal activities related to our Services. We do not disclose your personal information to third parties for their marketing and advertising purposes without your explicit consent.
                                </span>
                            </p>
                        
                        <h3 className="pg ftr">
                            4. LINKS TO OTHER SITES/APPS
                        </h3>
                            <p className="pg"><span style={{"fontWeight": "300"}}>
                            Our Website links to other websites/Websites that may collect personally identifiable information about you. Stylecabbie is not responsible for the privacy practices or the content of those linked websites/Websites.
                                </span>
                            </p>

                            <h3 className="pg ftr">
                            5. SECURITY PRECAUTIONS
                        </h3>
                            <p className="pg"><span style={{"fontWeight": "300"}}>
                            Our Website has stringent security measures in place to protect the loss, misuse, and alteration of the information under our control. Whenever you change or access your account information, we offer the use of a secure server. Once your information is in our possession we adhere to strict security guidelines, protecting it against unauthorized access.
                                </span>
                            </p>

                            <h3 className="pg ftr">
                            6. CHOICE/OPT-OUT
                        </h3>
                            <p className="pg"><span style={{"fontWeight": "300"}}>
                            We provide all users with the opportunity to opt-out of receiving non-essential (promotional, marketing-related) communications from us on behalf of our partners, and from us in general, after setting up an account. If you want to remove your contact information from all our lists and newsletters.
                             {/* please visit unsubscribe. */}
                                </span>
                            </p>

                            <h3 className="pg ftr">
                            7. ADVERTISEMENTS ON THE WEBSITE
                        </h3>
                            <p className="pg"><span style={{"fontWeight": "300"}}>
                            We use third-party advertising companies to serve ads when you visit our Website. These companies may use information (not including your name, address, email address, or telephone number) about your visits to this and other websites/Websites in order to provide advertisements about goods and services of interest to you. Refund Policy (No Refund, Exchange Only) All products are sold “as is”. You assume the responsibility for your purchase, and no refunds will be issued. You may contact us within 7 days from the purchase date if you wish to exchange your purchase for a product of equal or lesser value.
                                </span>
                            </p>
                        
                    </div>
                </main>

                <Footer />

            </React.Fragment>
        )
    }
}
export default  PrivacyPolicy 
